import { IA11yModule } from "./A11yModule.types";

export const A11yModule = {} as IA11yModule;
